import { render, staticRenderFns } from "./mistakes.vue?vue&type=template&id=cb0847b0&scoped=true&"
import script from "./mistakes.vue?vue&type=script&lang=js&"
export * from "./mistakes.vue?vue&type=script&lang=js&"
import style0 from "./mistakes.vue?vue&type=style&index=0&id=cb0847b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0847b0",
  null
  
)

export default component.exports